import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface Props {
  selectedAECount: number;
  canConfirm: boolean;
  onClearAll: () => void;
}

const RightPanelHeader: React.FC<Props> = ({
  selectedAECount,
  canConfirm,
  onClearAll,
}) => {
  return (
    <Box
      sx={{
        p: 1.5,
        pb: 0.8,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.6rem",
          fontWeight: 700,
          color: "rgba(0,0,0,0.40)",
        }}
      >
        Se seleccionaron {selectedAECount} Aprendizajes Esperados
      </Typography>

      <Button
        variant="text"
        onClick={onClearAll}
        disabled={!canConfirm}
        sx={{
          fontFamily: "Montserrat",
          fontWeight: 600,
          fontSize: "0.6rem",
          color: canConfirm ? "#336B87" : "rgba(0,0,0,0.35)",
        }}
      >
        BORRAR TODOS
      </Button>
    </Box>
  );
};

export default RightPanelHeader;
